<template>
    <div v-if="isGlobalErrorShown">
        <slot name="errors">
            <not-found-page v-if="showNotFoundPage"></not-found-page>
            <no-access-page v-else-if="showNoAccessPage"></no-access-page>
            <general-error-page v-else-if="showGeneralErrorPage"></general-error-page>
        </slot>
    </div>
    <div v-else>
        <common-loading-icon
            v-if="isPageLoading"
            :upperText="$t('layouts.app.loading.heading_one')"
            :lowerText="$t('layouts.app.loading.heading_two')"
        ></common-loading-icon>
        <div :class="layoutClass">
            <app-trial-period
                v-if="showAppTrialPeriod"
                @toggle-billing-pricing-modal="toggleBillingPricingModal"
                @toggle-paywall-modal="togglePaywallModal"
            ></app-trial-period>
            <header
                class="app-layout__sidenav"
                :class="isSidenavVisible ? 'app-layout__sidenav--open' : 'app-layout__sidenav--close'"
            >
                <app-sidenav @toggle-sidenav="toggleSidenav" @open-paywall-modal="openPaywallModal"></app-sidenav>
            </header>

            <nav v-if="showNav" class="app-layout__topnav">
                <app-topnav @toggle-sidenav="toggleSidenav"></app-topnav>
            </nav>

            <main class="app-layout__content">
                <slot></slot>
            </main>

            <terms-of-use></terms-of-use>

            <!-- <referral-complete-overlay v-if="!$auth.isUserPracticeOther()"></referral-complete-overlay> -->

            <portal-target name="modals"></portal-target>
            <billing-pricing-modal
                v-if="billingPricingModalOpen"
                mode="subscription"
                @close="toggleBillingPricingModal"
                @subscription-created="subscriptionCreated"
            ></billing-pricing-modal>
            <paywall-modal v-if="isPaywallModalOpen" @close="isPaywallModalOpen = false"></paywall-modal>
            <common-notification ref="commonSuccessNotificationChild" :content="notificationMessage"></common-notification>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { importComponents } from '~/helpers'
    import TermsOfUse from 'components/page-elements/terms-of-use/TermsOfUseFooter'
    import VersionUpdateServiceWorkerMixin from 'mixins/VersionUpdateServiceWorkerMixin'
    import BillingPricingModal from 'components/page-elements/practice/billing/BillingPricingModal'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    // import ReferralCompleteOverlay from 'components/overlays/ReferralCompleteOverlay'
    import PracticePlanEnum from '@/enums/PracticePlanEnum'
    import PaywallModal from 'components/page-elements/PaywallModal'

    export default {
        mixins: [VersionUpdateServiceWorkerMixin, ScreenSizeDetectionMixin],

        components: {
            ...importComponents(require.context('pages/errors')),
            ...importComponents(require.context('components/layouts/app-layout')),
            TermsOfUse,
            BillingPricingModal,
            // ReferralCompleteOverlay,
            PaywallModal,
        },

        props: {
            isPlain: { type: Boolean, default: false },
            byword: { type: String, default: undefined },
            image: { type: Number, default: 1 },
            isGlobalErrorHandlerUsed: { type: Boolean, default: true },
            printClass: { type: String, default: null },
            showTrialPeriodBar: { type: Boolean, default: true },
            isPageLoading: { type: Boolean, default: false },
        },

        data() {
            return {
                billingPricingModalOpen: false,
                isPaywallModalOpen: false,
                isSidenavVisible: false,
                PracticePlanEnum: PracticePlanEnum,
                notificationMessage: '',
            }
        },

        computed: {
            ...mapGetters({
                showNotFoundPage: 'ui/getShowNotFoundPage',
                showNoAccessPage: 'ui/getShowNoAccessPage',
                showGeneralErrorPage: 'ui/getShowGeneralErrorPage',
            }),

            showAppTrialPeriod() {
                return (
                    this.showTrialPeriodBar &&
                    !this.$auth.isPracticePremium() &&
                    !this.$auth.isPracticeOther() &&
                    !this.$auth.isUserTemporaryPhysician()
                )
            },

            layoutClass() {
                return {
                    'app-layout': true,
                    'app-layout--trial': this.showAppTrialPeriod,
                    'app-layout--mobile': this.isSidenavVisible,
                    [this.printClass]: this.printClass,
                    'app-layout--loading': this.isPageLoading,
                }
            },

            isGlobalErrorShown() {
                return this.isGlobalErrorHandlerUsed
                    ? this.showNotFoundPage || this.showNoAccessPage || this.showGeneralErrorPage
                    : false
            },

            showNav() {
                return (
                    this.$auth.getActiveMember() ||
                    this.$auth.isUserPracticeOther() ||
                    this.$auth.isUserPracticeDemo() ||
                    this.$auth.isUserTemporaryPhysician()
                )
            },
        },

        methods: {
            subscriptionCreated() {
                this.notificationMessage = this.$t('pages.practice.billing.subscription_created')
                this.$refs.commonSuccessNotificationChild.showNotification()
                this.toggleBillingPricingModal()
            },
            toggleBillingPricingModal() {
                this.billingPricingModalOpen = !this.billingPricingModalOpen
                if (this.billingPricingModalOpen) {
                    document.body.classList.add('no-scroll')
                } else {
                    document.body.classList.remove('no-scroll')
                }
            },
            toggleSidenav() {
                this.isSidenavVisible = !this.isSidenavVisible
            },

            togglePaywallModal() {
                this.isPaywallModalOpen = !this.isPaywallModalOpen
            },

            openPaywallModal() {
                this.togglePaywallModal()
            },
        },
    }
</script>
